import {Wallet as WalletIcon, WalletIconSmall, WarningIcon} from '../../../ui-components/Iconpack';
import {nFetch} from '../../../api/nFetch';
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {RootState, useAppDispatch} from '../../../store';
import {cn, formatDate} from '../../../ui-components/lib/utils';
import {CommonSpinLoader} from '../../../ui-components/loaders';
import CoinIcon from '../../../assets/icons/coin_icon.svg';
import {Button} from '../../../ui-components/Button/button';
import {Dialog, DialogContent, DialogTitle} from '../../../ui-components/Modal';
import PixelLogoHeader from '../../../assets/icons/pixel-logo-dialog.svg';
import {toast, ToastContainer} from 'react-toastify';
import {getWalletBalance} from '../../../actions/metrics';
import Tracker from '../../../lib/analytics/tracker';
import {EventNames, EventProperty} from '../../../lib/analytics/events';
import DollarCoin from '../../../assets/animations/dollar-coin.gif';
import AddCredits from './AddCredits';

interface Transaction {
    uid: string;
    amount: number;
    transaction_type: number;
    source: string;
    source_ref_id: string;
    description: string;
    created_at: string;
}

interface TransactionHistory {
    count: number;
    next: string | null;
    previous: string | null;
    results: Transaction[];
}
export default function Wallet() {
    const [userProfileProps, metricsProps] = [
        useSelector((state: RootState) => state.userProfile),
        useSelector((state: RootState) => state.metrics),
    ];
    const org_uid = userProfileProps.currentOrganization.uid;

    const [walletBalance, setWalletBalance] = useState(0);
    const [transactions, setTransactions] = useState<TransactionHistory>();
    const [showCreditsAdditionWindow, setShowCreditsAdditionWindow] = useState(false);

    const resetCouponState = () => {
        setShowCreditsAdditionWindow(false);
    };

    useEffect(() => {
        nFetch<any>(`/reward/transactions?org_uid=${org_uid}`).then((res) => {
            if (!!res.error) {
                setTransactions({count: 0, next: null, previous: null, results: []});
                // throw res.error;
            } else {
                setTransactions(res.data);
            }
        });
    }, [org_uid, metricsProps.balance]);

    useEffect(() => {
        if (metricsProps.balance) {
            setWalletBalance(metricsProps.balance);
        }
    }, [metricsProps.balance]);

    return (
        <div className='m-8 rounded-md border border-gray-200'>
            <div className='flex items-center gap-4'>
                <div className='m-5 rounded-md bg-[#EAECF0] p-3'>
                    <WalletIcon />
                </div>
                <span className='font-[600] text-gray-700'>Wallet</span>
            </div>
            <div className='flex justify-between border-t border-gray-200 px-5 pt-5'>
                <span className='font-[600]'>Credits in Wallet</span>
                <div className='flex flex-col'>
                    <span className='font-[500] text-[#535353]'>Credits</span>
                    <div className='flex gap-2'>
                        <img src={CoinIcon} alt='coin' />
                        <span className='font-[500] text-[#535353]'>{walletBalance}</span>
                    </div>
                </div>
            </div>
            <div className='flex flex-col gap-2 pl-5'>
                <Button
                    onClick={() => {
                        setShowCreditsAdditionWindow(true);
                        Tracker.trackEvent(EventNames.ADD_CREDITS_CLICKED);
                    }}>
                    Add Credits
                </Button>
            </div>
            <div className='m-6 rounded-md border border-[#EAEAEC]'>
                <span className='flex justify-center py-5 font-[600]'>Transaction Log</span>
                {!transactions && (
                    <div className='flex items-center justify-center'>
                        <CommonSpinLoader />
                    </div>
                )}
                {transactions &&
                    transactions.results.length > 0 &&
                    transactions.results.map((transaction) => (
                        <div
                            key={transaction.uid}
                            className='flex items-center justify-between border-y border-[#EAEAEC] p-6'>
                            <div className='flex flex-col'>
                                <span className='font-[500]'>
                                    {transaction.description.charAt(0).toUpperCase() + transaction.description.slice(1)}
                                </span>
                            </div>

                            <div className='flex flex-col'>
                                <span className='font-[400] text-[#454545]'>{formatDate(transaction.created_at)}</span>
                                <span
                                    className={`flex justify-end font-[400] ${transaction.amount > 0 ? 'text-[#1EA153]' : 'text-[#EF5A5A]'}`}>
                                    {transaction.amount > 0 ? `+${transaction.amount}` : `${transaction.amount}`}
                                </span>
                            </div>
                        </div>
                    ))}
                {transactions && transactions.results.length === 0 && <span>No transactions yet</span>}
            </div>
            <Dialog open={showCreditsAdditionWindow}>
                <DialogContent className='w-[796px] p-0' style={{borderRadius: '1rem'}} onClose={resetCouponState}>
                    <DialogTitle />
                    <AddCredits walletBalance={walletBalance} org_uid={org_uid} resetCouponState={resetCouponState} />
                </DialogContent>
            </Dialog>
            <ToastContainer />
        </div>
    );
}
